/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PropertyInputs */

const cs_enum_property = /** @type {(inputs: Enum_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`za nemovitost`)
};

const en_enum_property = /** @type {(inputs: Enum_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per property`)
};

/**
* | output |
* | --- |
* | "per property" |
*
* @param {Enum_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_property = /** @type {((inputs?: Enum_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_property(inputs)
	return cs_enum_property(inputs)
});